// @ts-check
/**
 * @param {import('./utils/broker').Broker} broker
 * @param {import('./cmp/Cmp').Cmp} cmp
 * @param {import('./ui/Ui').default} ui
 */
export default function clientApi (broker, cmp, ui) {
  broker.on('open', ({ uiLevel, uuid }) => {
    if (uuid) {
      cmp.setUuid(uuid)
    }
    cmp.openUi(uiLevel)
  })

  broker.on('dissentToAll', ({ uuid }) => {
    ui.close()
    cmp.setUuid(uuid)
    cmp.setCurrentLevel('Level1')
    cmp.dissentToAll()
  })

  broker.on('consentToAll', ({ uuid }) => {
    ui.close()
    cmp.setUuid(uuid)
    cmp.setCurrentLevel('Level1')
    cmp.consentToAll()
  })

  broker.on('ads-initialised', () => {
    // send message to Ui
    ui.notifyUserPreferenceCaptured()
  })
}
